export default __webpack_public_path__ + "static/media/sadms-reports-logo.cea0a66a.svg";